var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.parts),function(part){return _c('Carousel',{key:part + _vm.getContent(part).length /* to force re-render */,attrs:{"kind":_vm.kind,"part":part,"has-at-least-one-image":_vm.hasImage,"choices":_vm.getContent(part)},on:{"openEditTextDialog":_vm.openEditTextDialog,"change":_vm.handleChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }